export default {
    app: 'malenia',
    api_prefix: "/malenia-api",
    login_token_key: 'Malenia-Token',
    login_user_key: "Malenia-USER",
    doc_path: '/malenia-doc/index.html',
    logo_path: '/images/logos/logo.png',
    main_site: 'http://malenia.iinti.cn/',
    footer: 'malenia-系统框架',
    copyRight: '2023 因体信息公司'
}